export default __webpack_public_path__ + "static/media/Flag of Fiji.facb8650.gif";